'use client'

import { Carousel } from '~/components/Carousel'
import { PartnerCard } from '~/components/PartnerCard'
import { Section } from '~/components/Section'
import { getPartnerSlug, PARTNERS } from '~/utils/partners-info'

export const WeAreYourPartners = () => (
  <Section
    aria-label="We're your partners"
    data-testid="partners-section"
    paddingY="md"
    className="dark rounded-b-6xl bg-card"
  >
    <div className="flex flex-col gap-8">
      <h2 className="text-title-xl text-center text-foreground">We&apos;re your partners — not salespeople</h2>

      <Carousel
        items={PARTNERS}
        getKey={(partner) => partner.name}
        getDotLabel={(partner) => `Go to ${partner.name}`}
        controlNoun="partner"
        itemClassName="w-[305px] tablet:w-[563px]"
        renderItem={(partner) => (
          <PartnerCard.Container className="h-full">
            <PartnerCard.Image src={partner.imageUrl} alt={partner.name} />
            <PartnerCard.Info
              name={partner.name}
              bio={partner.bio}
              credential={partner.credential}
              profileSlug={partner.enableProfileLandingPage ? getPartnerSlug(partner.name) : undefined}
            />
          </PartnerCard.Container>
        )}
      />
    </div>
  </Section>
)
